import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import {
  ColoredText,
  CommonFlex,
  CommonText,
  Container,
  RoundLetterSection,
  TableText,
} from '../../styledComponents/common';
import { AssignedProjectBox, TableItem } from '../../styledComponents/teams';
import { CommFirstRoundLetterComp } from '../Teams/CommonComponents';
import {
  TaskLocationsTableHeaderContainer,
  TaskLocationsTableRowContainer,
} from './taskLocationsStyles';
import editIcon from 'assets/img/edit.svg';
import archiveIcon from 'assets/img/archive.svg';
import { CommonImage } from '../../styledComponents/common';
import TaskArchiveModal from './TaskArchiveModal';

const TaskLocationsTable = props => {
  const { t } = useTranslation();
  const [locationToArchive, setLocationToArchive] = useState(null);

  // Get user role from localStorage
  const userRole = localStorage.getItem('user_role');
  const isAdmin = userRole === 'admin' && localStorage.getItem('viewer_role') !== 'management';
  const { i18n } = useTranslation();

  const {
    locationsList,
    isLoading,
    handleShowLocation,
    handleEditLocation,
    locationTypeList,
    archiveTaskLocation,
    // selectedOrganization,
    isArchiving
  } = props;

  const handleArchiveClick = (location) => {
    console.log('location', location);
    setLocationToArchive(location);
  };

  const confirmArchive = () => {
    if (locationToArchive) {
      archiveTaskLocation({
        location_id: locationToArchive.id,
        is_active: locationToArchive.is_active ? false : true,
        // organization_id: selectedOrganization.id,
        refetchList: true
      });
      setLocationToArchive(null);
    }
  };

  const cancelArchive = () => {
    setLocationToArchive(null);
  };


  const getLocationType = (location) => {
    // if language is arabic, return the location type in arabic
    if (i18n.language === 'ar') {
      return location?.location_type_arabic || location.location_type;
    }
    return location.location_type;
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <TaskLocationsTableHeaderContainer>
              <TableItem>
                <TableText>{t('location_name')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('office')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('registration_number')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location_address')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location_type')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location_radius')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location')}</TableText>
              </TableItem>
              {isAdmin && (
                <TableItem>
                  <TableText>{t('actions')}</TableText>
                </TableItem>
              )}
            </TaskLocationsTableHeaderContainer>
            {locationsList && locationsList.length > 0 ? (
              locationsList.map((location, index) => (
                <TaskLocationsTableRowContainer key={location.id}>
                  <TableItem>
                    <CommFirstRoundLetterComp
                      text={location.name}
                      backColor={index}
                      underline={false}
                    />
                  </TableItem>
                  <TableItem>
                    <CommonText>
                      {location.office && location.office.id
                        ? location.office.name
                        : '-'}
                    </CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>
                      {location.house_reg_no ? location.house_reg_no : '-'}
                    </CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>{location.address}</CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>{getLocationType(location)}</CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>{location.radius} m</CommonText>
                  </TableItem>
                  <TableItem>
                    <ColoredText
                      type="warning"
                      hover
                      onClick={() => handleShowLocation(location)}
                      fontSize="14px"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('see_location')}
                    </ColoredText>
                  </TableItem>
                  {isAdmin && (
                    <TableItem>
                      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <CommonImage
                          src={editIcon}
                          alt="Edit"
                          size="36px"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleEditLocation(location)}
                          title={t('edit')}
                        />
                        {location.is_active ? (
                          <CommonImage
                            src={archiveIcon}
                            alt="Archive"
                            size="36px"
                            style={{
                              cursor: 'pointer',
                              border: '2px solid #ef6969',
                              borderRadius: '50%',
                              padding: '2px'
                            }}
                            onClick={() => handleArchiveClick(location)}
                            title={t('archive')}
                          />
                        ) : (
                          <CommonImage
                            src={archiveIcon}
                            alt="Unarchive"
                            size="36px"
                            style={{
                              cursor: 'pointer',
                              border: '2px solid #28a745',
                              borderRadius: '50%',
                              padding: '2px'
                            }}
                            onClick={() => handleArchiveClick(location)}
                            title={t('unarchive')}
                          />
                        )}
                      </div>
                    </TableItem>
                  )}
                </TaskLocationsTableRowContainer>
              ))
            ) : (
              <NoDataComponent
                title={t('no_task_locations_found')}
                padding="5vh 0"
                imageHeight="140px"
              />
            )}
          </>
        )}
      </div>

      {locationToArchive && (
        <TaskArchiveModal
          isOpen={!!locationToArchive}
          toggle={() => setLocationToArchive(null)}
          handleSave={confirmArchive}
          isLoading={isArchiving}
          location={locationToArchive}
        />
      )}

    </Container>
  );
};

export default TaskLocationsTable;
